<style>
</style>
<template>
<v-text-field solo flat persistent-hint
              v-if="!hidden"
              :hint="hintValue"
              :label="$t(label)"
              :placeholder="placeholder"
              :value="inputValue"
              @input="getInput"
              :clearable="clearable"
              :counter="counter ? counter : false"
              :mask="mask"
              :rules="rules"
              :disabled="disabled"
              :error="error"
              :error-messages="$t(errorMessage)"
              :required="required"
></v-text-field>
</template>
<script>
import TransformMixin from '../mixins/transform-mixin.js'

export default {
  name: 'setting-value',
  props: {
    name: {
      type: String,
      default: 'title'
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    required: {
        type: Boolean,
        default: false
    },
    hidden: {
        type: Boolean,
        default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Number,
      default: 0
    },
    mask: {
      type: String,
      default: null
    },
    defaultValue: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    capitalize: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  mixins: [TransformMixin],
  data() {
    return {
      rules: [
        (v) => !!v || !this.required || this.transform(this.hintValue),
        // (v) => (!v || !this.counter || v.length <= this.counter) || this.transform('tooLong'),
        (v) => this.labelValue !== 'email' || !v || this.rule.email(v),
        (v) => this.labelValue !== 'phone' || this.rule.phone(v),
        (v) => this.labelValue !== 'loginName' || this.rule.loginName(v),
        () => !this.error || this.transform(this.hintValue)
      ],
      rule: {
        email: (v) => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || this.transform(this.hintValue),
        phone: (v) => (/^\d+$/.test(v)) || this.transform(this.hintValue),
        loginName: (v) => (!v || v.length >= 5) || this.transform(this.hintValue)
      }
    }
  },
  computed: {
    error: {
      get() {
        return this.errorMessage !== null
      }
    },
    hintValue: {
      get() {
        return this.transform(this.hint ? this.hint : this.name) + (this.required ? ' *' : '')
      }
    },
    inputValue: {
      get() {
        return this.value ? this.value : this.defaultValue
      }
    }
  },
  methods: {
    getInput(value) {
      if (value && this.capitalize) {
        value = value.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')
      }
      this.$emit('input', value)
    }
  }
}
</script>
